import { OrganisationLinkedScorecard } from "../../../Component/Model/Dto/Organisation/OrganisationLinkedScorecard";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { LongTableDateHelper } from "../../../Component/Model/helpers";


interface LinkedScorecardRows {
    scorecardId: string,
    scorecardName: string,
    startDate: string,
    endDate: string,
    actions: ActionType[];
}

interface OrganisationTable {
    columns: Array<TableColumn>;
    rows: Array<LinkedScorecardRows>;
}

export function LinkedScorecardTableMapper(dataRows: OrganisationLinkedScorecard.SearchDto[], handleUnlink: (id: string, scorecardName: string) => void): OrganisationTable {
    const columns = [
        { Header: 'Scorecard Name', accessor: 'scorecardName', Cell: ({ value }: any) => <DefaultCell value={value} />,  disableSortBy: true},
        { Header: 'Start Date', accessor: 'startDate', Cell: ({ value }: any) => <DefaultCell value={value} />,  disableSortBy: true},
        { Header: 'End Date', accessor: 'endDate', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];
    if (dataRows != undefined && dataRows.length > 0) {
        const rows = dataRows.map((item: OrganisationLinkedScorecard.SearchDto, index: number) => ({
            scorecardId: item.scorecardId,
            scorecardName: item.scorecardName,
            startDate: LongTableDateHelper(item.startDate) ?? '',
            endDate: LongTableDateHelper(item.endDate) ?? '',
            actions: [
                {
                    key: item.scorecardId,
                    label: 'Unlink Scorecard',
                    action: () => handleUnlink(item.scorecardId, item.scorecardName),
                    icon: { color: 'error', name: 'delete' }
                }
            ]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}